module.exports = __webpack_public_path__ + "img/icon-hzz.b8b122a6.png";